module.exports = __webpack_public_path__ + "static/img/test3.3e964bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/test/test3.jpg
// module id = SIef
// module chunks = 2